<template>
    <div>
        <b-modal id="modal-guardar-qr" size="lg"
            hide-footer :visible="visible"
            @show="onModalShow"
            @hidden="onModalHidden"
            @change="$emit('change', $event)"
            header-class="p-0 border-0"
            body-class="p-0">
            <template #modal-header="{ close }">
                <div class="w-100">
                    <div class="d-flex justify-content-between align-items-center px-3 py-2">
                        <div class="d-flex align-items-center">
                            <span class="dot-estado mr-2" :class="dotClase"></span>
                            <span class="font-weight-bold" style="font-size: 0.95rem;">{{ estadoTexto }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="font-weight-bold mr-3" style="font-size: 0.9rem; color: #666;">{{ tiempoFormateado }}</span>
                            <span @click="close()" style="cursor: pointer; font-size: 1.3rem; line-height: 1; color: #999;">&times;</span>
                        </div>
                    </div>
                    <div class="barra-progreso">
                        <div class="barra-progreso-fill" :style="{ width: progresoBar + '%' }"></div>
                    </div>
                </div>
            </template>

            <div class="container-fluid p-3">
                <div class="row">
                    <!-- Izquierda: QR -->
                    <div class="col-md-5 d-flex flex-column align-items-center mb-3 mb-md-0">
                        <div class="qr-empresa-label">{{ qrActual ? (qrActual.cuenta_cliente || '---') : '---' }}</div>
                        <div class="qr-imagen-box">
                            <img
                                v-if="qrActual && qrActual.imagen_qr_base64"
                                :src="'data:image/png;base64,' + qrActual.imagen_qr_base64"
                                class="w-100 d-block" alt="QR Code">
                        </div>
                        <div class="qr-alias-label">
                            {{ qrActual ? qrActual.alias : '---' }} &nbsp;&middot;&nbsp; vence en {{ minutosRestantes }} min
                        </div>
                    </div>

                    <!-- Derecha: detalles y acciones -->
                    <div class="col-md-7 d-flex flex-column">
                        <!-- Monto -->
                        <div class="mb-3">
                            <div style="font-size: 0.75rem; color: #888; margin-bottom: 2px;">Total a cobrar</div>
                            <div class="monto-total">{{ importeFormateado }}</div>
                        </div>

                        <!-- Info -->
                        <div class="info-rows mb-3">
                            <div v-if="ventaNumero" class="info-row">
                                <span class="info-label">Venta:</span>
                                <span class="info-value">{{ ventaNumero }} {{ getCompany.tradename }}</span>
                            </div>
                            <div v-if="ciNit" class="info-row">
                                <span class="info-label">CI/NIT:</span>
                                <span class="info-value">{{ ciNit }}</span>
                            </div>
                            <div v-if="estadoQR" class="info-row">
                                <span class="info-label">Estado:</span>
                                <span
                                  class="info-value font-weight-bold"
                                  :class="estadoQR.clase.includes('success') ? 'text-success' : 'text-dark'">
                                    {{ estadoQR.estado }}
                                </span>
                            </div>
                        </div>

                        <!-- Botones -->
                        <div class="d-flex mb-2">
                            <b-button
                                variant="primary"
                                class="btn-success mr-2 flex-fill"
                                @click="verEstado"
                                :disabled="cargandoEstado">
                                <span v-if="cargandoEstado"><i class="i-Loading-3 spin mr-1"></i></span>
                                <i v-else class="i-Repeat-2 mr-1"></i>
                                Ver estado
                            </b-button>
                            <b-button
                                variant="outline-danger"
                                class="btn-cancelar"
                                @click="generarOtro"
                                :disabled="cargandoNuevo || qrPagado">
                                <span v-if="cargandoNuevo"><i class="i-Loading-3 spin"></i></span>
                                <span v-else>Generar otro</span>
                            </b-button>
                        </div>

                        <!-- Usar Pago -->
                        <div class="usar-pago-box mt-3">
                            <div class="usar-pago-titulo">
                                <i class="i-Information mr-1"></i>
                                &iquest;El cliente ya pag&oacute; antes y no se guard&oacute;?
                            </div>
                            <div class="d-flex mt-2">
                                <input
                                    v-model="codigoRef"
                                    type="text"
                                    class="form-control mr-2"
                                    placeholder="Código QR (ej: QR-00142)"
                                    style="font-size: 0.8rem;"
                                    :disabled="true"
                                >
                                <b-button
                                    variant="primary"
                                    class="btn-success"
                                    :disabled="cargandoUsarPago || qrPagado">
                                    <span v-if="cargandoUsarPago"><i class="i-Loading-3 spin"></i></span>
                                    <span v-else>Verificar</span>
                                </b-button>
                            </div>
                            <div class="usar-pago-ayuda">
                                Recuperar&aacute; un pago confirmado por el banco que no se asoci&oacute; a una venta.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Mini modal: Pago Encontrado -->
        <b-modal
            v-model="showModalPago"
            hide-footer
            hide-header
            centered
            size="sm"
            body-class="p-0"
            no-enforce-focus>
            <div v-if="pagoEncontrado">
                <div class="pago-encontrado-header">
                    <div class="d-flex align-items-start">
                        <div class="pago-encontrado-icon mr-2">
                            <i class="i-Clock"></i>
                        </div>
                        <div>
                            <div class="pago-encontrado-titulo">Pago encontrado</div>
                            <div class="pago-encontrado-ref">
                                {{ pagoEncontrado.transaccion.alias }}&nbsp;&middot;&nbsp;{{ pagoEncontrado.tiempoRelativo }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pago-detalle-card">
                    <div class="pago-detalle-row">
                        <span class="pago-detalle-label">Monto recibido:</span>
                        <span class="pago-detalle-value font-weight-bold">{{ pagoEncontrado.montoFormateado }}</span>
                    </div>
                    <div class="pago-detalle-row">
                        <span class="pago-detalle-label">Referencia banco:</span>
                        <span class="pago-detalle-value">{{ pagoEncontrado.referenciaBanco }}</span>
                    </div>
                    <div class="pago-detalle-row">
                        <span class="pago-detalle-label">QR original:</span>
                        <span class="pago-detalle-value">{{ pagoEncontrado.transaccion.alias }}</span>
                    </div>
                    <div class="pago-detalle-row">
                        <span class="pago-detalle-label">Hora cobro:</span>
                        <span class="pago-detalle-value">{{ pagoEncontrado.horaCobro }}</span>
                    </div>
                    <div class="pago-detalle-row">
                        <span class="pago-detalle-label">Estado:</span>
                        <span class="pago-detalle-value text-success font-weight-bold">{{ pagoEncontrado.estadoDisplay }}</span>
                    </div>
                </div>

                <div class="pago-advertencia">
                    Al usar este pago, se asociar&aacute; a <strong>{{ ventaNumero }} &middot; {{ pagoEncontrado.montoFormateado }}</strong> y quedar&aacute; bloqueado para no reutilizarse.
                </div>

                <div class="d-flex p-3">
                    <b-button variant="outline-secondary" class="flex-fill mr-2" @click="cancelarPago">
                        Cancelar
                    </b-button>
                    <b-button variant="primary" class="flex-fill" @click="confirmarUsarPago">
                        Usar pago
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import axios from '@/modules/common/axiosERP';
import moment from 'moment';
import { util } from '../../../plugins/util';

export default {
  name: 'theMoldalQR',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
      required: true,
    },
    qrData: {
      type: Object,
      default: null,
    },
    nombreCliente: {
      type: String,
      default: '',
    },
    ciNit: {
      type: String,
      default: '',
    },
    ventaNumero: {
      type: String,
      default: '',
    },
    glosa: {
      type: String,
      default: '',
    },
    montoQR: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      timer: null,
      tiempoRestante: 600,
      estadoQR: null,
      cargandoEstado: false,
      cargandoNuevo: false,
      qrActual: null,
      pagoEncontrado: null,
      showModalPago: false,
      cargandoUsarPago: false,
      codigoRef: '',
    };
  },
  methods: {
    iniciarContador() {
      if (this.qrActual && this.qrActual.fecha_vencimiento) {
        const diff = moment(this.qrActual.fecha_vencimiento).diff(moment(), 'seconds');
        this.tiempoRestante = Math.max(0, Math.min(diff, 600));
      } else {
        this.tiempoRestante = 600;
      }
      if (this.timer) clearInterval(this.timer);
      if (this.tiempoRestante <= 0) {
        return;
      }
      this.timer = setInterval(() => {
        if (this.tiempoRestante > 0) {
          this.tiempoRestante -= 1;
        } else {
          clearInterval(this.timer);
          this.manejarTiempoAgotado();
        }
      }, 1000);
    },
    detenerContador() {
      clearInterval(this.timer);
    },
    async verEstado() {
      if (!this.qrActual) return;
      this.cargandoEstado = true;
      try {
        const transaccionId = this.qrActual.transaccion_id || this.qrActual.id;
        const response = await axios.post(`/qr/state/${transaccionId}`, {
          origen: 1,
          medico_id: null,
          alias: this.qrActual.alias,
          motivo: 'por falta de datos',
        });
        const { transaccion } = response.data.data.data;
        const estadoActual = (transaccion.estadoBanco && transaccion.estadoBanco.estadoActual)
          || (transaccion.transaccion && transaccion.transaccion.estado)
          || '---';
        const mensaje = (transaccion.estadoBanco && transaccion.estadoBanco.mensaje) || '';
        const estadoUpper = String(estadoActual).toUpperCase();
        const esPagado = estadoUpper.includes('PAGAD') || estadoUpper.includes('PROCES');
        this.estadoQR = {
          estado: estadoActual,
          mensaje,
          clase: esPagado ? 'bg-success text-white' : 'bg-light border text-dark',
        };
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : 'No se pudo consultar el estado.';
        this.estadoQR = { estado: 'Error', mensaje: msg, clase: 'bg-danger text-white' };
      } finally {
        this.cargandoEstado = false;
      }
    },
    async onModalShow() {
      this.iniciarContador();
      await this.consultarEstadoQr('verificacion al abrir modal', false);
    },
    async onModalHidden() {
      this.detenerContador();
      await this.consultarEstadoQr('verificacion al cerrar modal', true);
    },
    async consultarEstadoQr(motivo, emitirSiPagado) {
      if (!this.qrActual) return;
      const transaccionId = this.qrActual.transaccion_id || this.qrActual.id;
      if (!transaccionId) return;
      try {
        const response = await axios.post(`/qr/state/${transaccionId}`, {
          origen: 1,
          medico_id: null,
          alias: this.qrActual.alias,
          motivo,
        });
        const { transaccion } = response.data.data.data;
        const estadoActual = (transaccion.estadoBanco && transaccion.estadoBanco.estadoActual)
          || (transaccion.transaccion && transaccion.transaccion.estado)
          || '';
        const mensaje = (transaccion.estadoBanco && transaccion.estadoBanco.mensaje) || '';
        const estadoUpper = String(estadoActual).toUpperCase();
        const esPagado = estadoUpper.includes('PAGAD') || estadoUpper.includes('PROCES');
        this.estadoQR = {
          estado: estadoActual,
          mensaje,
          clase: esPagado ? 'bg-success text-white' : 'bg-light border text-dark',
        };
        if (esPagado && emitirSiPagado) {
          this.$emit('qr-pagado-cerrado');
        }
      } catch (error) {
        // silencioso: no romper flujo si falla el state
      }
    },
    async generarOtro() {
      if (!this.qrActual) return;
      if (this.qrPagado) return;
      if (!this.glosa) {
        util.showNotify('Por favor ingrese una glosa antes de generar el QR.', 'warn');
        return;
      }
      this.cargandoNuevo = true;
      this.estadoQR = null;
      try {
        const payload = {
          monto: this.montoEfectivo,
          moneda: this.qrActual.moneda,
          detalle_glosa: this.glosa || '',
          fecha_vencimiento: moment().add(1, 'days').format('YYYY-MM-DD'),
          origen: 1,
          medico_id: null,
        };
        const response = await axios.post('/qr/generate', payload);
        const qrGenerado = response.data.data.data;
        const txId = qrGenerado.transaccion_id || qrGenerado.id;
        this.qrActual = { ...qrGenerado, transaccion_id: txId };
        this.pagoEncontrado = null;
        this.$emit('update:qrData', this.qrActual);
        this.$emit('nuevo-qr', this.qrActual);
        this.iniciarContador();
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : 'Error al generar el QR.';
        util.showNotify(msg, 'error');
      } finally {
        this.cargandoNuevo = false;
      }
    },
    async buscarPago() {
      const alias = this.codigoRef.trim();
      if (!alias) {
        util.showNotify('Ingrese un c&oacute;digo QR para verificar.', 'warn');
        return;
      }
      this.cargandoUsarPago = true;
      this.pagoEncontrado = null;
      try {
        const response = await axios.post('/qr/detail', {
          origen: 1,
          medico_id: null,
          alias,
        });
        const { transaccion, response_banco: responseBanco } = response.data.data.data;

        const banco = (responseBanco && responseBanco[0]) || {};
        const moneda = transaccion.moneda === 'BOB' ? 'Bs.' : transaccion.moneda;
        const montoFormateado = `${moneda} ${Number(transaccion.monto).toFixed(2)}`;
        const referenciaBanco = transaccion.numero_orden_originante || banco.idQr || '---';
        const fechaProceso = transaccion.fecha_proceso || banco.fechaProceso || null;
        const horaCobro = fechaProceso ? moment(fechaProceso).format('DD/MM/YYYY HH:mm') : '---';
        const tiempoRelativo = moment(transaccion.created_at).fromNow();
        const estadoMap = {
          Pagado: 'Libre &mdash; nunca usado',
          Anulado: 'Anulado',
          Pendiente: 'Pendiente de pago',
        };
        const estadoDisplay = estadoMap[transaccion.estado] || transaccion.estado;

        this.pagoEncontrado = {
          transaccion,
          response_banco: responseBanco,
          referenciaBanco,
          montoFormateado,
          tiempoRelativo,
          horaCobro,
          estadoDisplay,
        };
        this.showModalPago = true;
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : 'No se encontr&oacute; un QR con ese c&oacute;digo.';
        util.showNotify(msg, 'error');
      } finally {
        this.cargandoUsarPago = false;
      }
    },
    cancelarPago() {
      this.showModalPago = false;
      this.pagoEncontrado = null;
      this.codigoRef = '';
    },
    confirmarUsarPago() {
      const { transaccion } = this.pagoEncontrado;
      const txId = transaccion.transaccion_id || transaccion.id;
      this.qrActual = { ...transaccion, transaccion_id: txId };
      this.estadoQR = null;
      this.$emit('update:qrData', this.qrActual);
      this.$emit('usar-pago', { transaccion: this.qrActual });
      this.showModalPago = false;
      this.pagoEncontrado = null;
      this.codigoRef = '';
      this.iniciarContador();
    },
    async manejarTiempoAgotado() {
      if (!this.qrActual) return;
      try {
        const id = this.qrActual.transaccion_id || this.qrActual.id;
        await axios.post(`/qr/destroy/${id}`, {
          origen: 1,
          medico_id: null,
          motivo: 'QR expirado por tiempo',
        });
      } catch (error) {
        // ignorar error de destroy, el QR ya expir&oacute;
      }
    },
    ...mapMutations('detalleFactura', [
      'addItemListaBadges',
    ]),
  },
  watch: {
    qrData: {
      immediate: true,
      handler(val) {
        this.qrActual = val;
      },
    },
    visible(val) {
      if (val) {
        this.iniciarContador();
      } else {
        this.detenerContador();
      }
    },
  },
  computed: {
    tiempoFormateado() {
      const minutos = Math.floor(this.tiempoRestante / 60);
      const segundos = this.tiempoRestante % 60;
      return `${minutos}:${segundos < 10 ? '0' : ''}${segundos}`;
    },
    minutosRestantes() {
      return Math.ceil(this.tiempoRestante / 60);
    },
    progresoBar() {
      return (this.tiempoRestante / 600) * 100;
    },
    estadoTexto() {
      if (this.tiempoRestante <= 0) return 'Tiempo Expirado';
      if (this.estadoQR) return this.estadoQR.estado;
      return 'Esperando pago';
    },
    dotClase() {
      if (this.tiempoRestante <= 0) return 'dot-danger';
      if (this.estadoQR && this.estadoQR.clase.includes('success')) return 'dot-success';
      return 'dot-warning';
    },
    titular() {
      return this.nombreCliente || '';
    },
    montoEfectivo() {
      if (this.montoQR !== null && this.montoQR !== undefined) {
        return Number(this.montoQR);
      }
      return Number(this.total);
    },
    qrPagado() {
      if (!this.estadoQR || !this.estadoQR.estado) return false;
      const e = String(this.estadoQR.estado).toUpperCase();
      return e.includes('PAGAD') || e.includes('PROCES');
    },
    importeFormateado() {
      if (!this.qrActual) return `Bs. ${Number(this.montoEfectivo).toFixed(2)}`;
      const moneda = this.qrActual.moneda === 'BOB' ? 'Bs.' : this.qrActual.moneda;
      return `${moneda} ${Number(this.qrActual.monto).toFixed(2)}`;
    },
    ...mapGetters('main', [
      'getCompany',
    ]),
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
    .barra-progreso {
        height: 3px;
        background: #eee;
    }
    .barra-progreso-fill {
        height: 100%;
        background: #076d1d;
        transition: width 1s linear;
    }
    .dot-estado {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: inline-block;
    }
    .dot-warning { background: #f0a500; }
    .dot-success { background: #28a745; }
    .dot-danger  { background: #dc3545; }

    .qr-empresa-label {
        font-size: 0.72rem;
        color: #555;
        margin-bottom: 6px;
        text-align: center;
        font-weight: 600;
    }
    .qr-imagen-box {
        width: 100%;
        border-radius: 8px;
        overflow: hidden;
        border: 2px solid #1a1a2e;
    }
    .qr-alias-label {
        font-size: 0.72rem;
        color: #555;
        margin-top: 6px;
        text-align: center;
    }

    .monto-total {
        font-size: 1.8rem;
        font-weight: 700;
        color: #1a1a2e;
        line-height: 1.2;
    }

    .info-rows { font-size: 0.8rem; }
    .info-row { margin-bottom: 2px; }
    .info-label { color: #888; margin-right: 4px; }
    .info-value { font-weight: 600; color: #333; }

    .btn-cancelar {
        border-radius: 8px;
        padding: 9px 14px;
        font-weight: 600;
        white-space: nowrap;
    }

    .usar-pago-box {
        border: 1.5px dashed #0c7c28;
        border-radius: 8px;
        background: #b8ffdb8f;
        padding: 12px 14px;
    }
    .usar-pago-titulo {
        font-size: 0.78rem;
        font-weight: 600;
        color: #000000;
    }
    .usar-pago-ayuda {
        font-size: 0.68rem;
        color: #000000;
        margin-top: 5px;
    }
    .btn-usar-pago {
        border-radius: 8px;
        font-weight: 600;
        font-size: 0.82rem;
    }

    .pago-encontrado-header {
        background: #e8f0fc;
        border-bottom: 1px solid #c8ddf7;
        padding: 10px 14px;
    }
    .pago-encontrado-icon {
        width: 32px;
        height: 32px;
        background: #c8ddf7;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        color: #2c5f9e;
        flex-shrink: 0;
    }
    .pago-encontrado-titulo {
        font-size: 0.95rem;
        font-weight: 700;
        color: #1a6e33;
        line-height: 1.2;
    }
    .pago-encontrado-ref {
        font-size: 0.72rem;
        color: #4aa559;
        margin-top: 1px;
    }

    .pago-detalle-card {
        background: #f8faff;
        border-bottom: 1px solid #e4ecf7;
        padding: 10px 14px;
    }
    .pago-detalle-row {
        display: flex;
        justify-content: space-between;
        font-size: 0.78rem;
        margin-bottom: 4px;
    }
    .pago-detalle-row:last-child { margin-bottom: 0; }
    .pago-detalle-label { color: #888; }
    .pago-detalle-value { color: #222; font-weight: 500; }

    .pago-advertencia {
        background: #fffbe6;
        border-top: 1px solid #ffe58f;
        border-bottom: 1px solid #ffe58f;
        padding: 8px 14px;
        font-size: 0.74rem;
        color: #7a4f00;
        line-height: 1.4;
    }
</style>
